import React, { useEffect, useRef } from "react";

function NoticeOverlay({ onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="searoad-notice-title"
        tabIndex={-1}
        className="relative w-[90%] max-w-2xl max-h-[85vh] overflow-y-auto rounded-2xl bg-white px-6 py-8 shadow-xl md:px-10"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="닫기"
          className="absolute top-4 right-4 text-lg text-gray-500 hover:text-gray-800"
        >
          X
        </button>
        <p
          id="searoad-notice-title"
          className="text-xl font-semibold text-gray-900 md:text-3xl"
        >
          천사뱃길 앱 지원 종료 및 안내 채널 변경
        </p>
        <div className="mt-4 text-sm text-gray-700 md:text-base">
          <p>
            천사뱃길 모바일 앱 지원은 종료되었습니다.
          </p>
          <p className="mt-2">
            여객선 운항정보 안내는 병풍도·대기점도·소악도 선착장 안내 단말기를 중심으로 제공되고 있으며,
            2024년부터 스마트빌리지 사업과 연계하여 현장 안내 서비스를 이어가고 있습니다.
          </p>
        </div>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
          <a
            href="https://co77iri.com/seaway-info"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-blue-950 px-4 py-2 text-sm font-semibold text-white hover:opacity-80"
          >
            상세 내용 확인
          </a>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="inline-flex items-center justify-center rounded-full border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-bg1"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoticeOverlay;
